import React, { useState, useRef, useEffect } from "react";
import TextField from "./TextField";

export interface SectionOption {
  section: string;
  options: Option[];
}

export interface Option {
  value: string;
  label: string;
}

interface Props {
  options: any;
  selectedOption?: Option | null;
  onSelect?: (option: Option) => void;
  placeholder?: string;
  dropdownLabel?: string;
  endAdornment?: React.ReactElement;
}

const Dropdown: React.FC<Props> = ({
  options,
  selectedOption,
  onSelect,
  placeholder,
  dropdownLabel,
  endAdornment,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState<any>(options);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleOptionClick = (option: Option, section?: string) => {
    if (onSelect) {
      onSelect(option);
    }
    setSearchTerm(option.label);
    setShowDropdown(false);
    inputRef.current?.blur();
  };

  const handleInputClick = () => {
    if (selectedOption?.label) {
      setSearchTerm("");
    }
    setShowDropdown(true);
  };

  const handleOutsideClick = (e: MouseEvent) => {
    if (inputRef.current && !inputRef.current.contains(e.target as Node)) {
      setShowDropdown(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  React.useEffect(() => {
    console.log("se", searchTerm);
    if (searchTerm) {
      let filtered: any = [];

      for (const opt of options) {
        if (opt?.options && opt.options.length) {
          let x = [];
          for (const item of opt.options) {
            if (item.label.toLowerCase().includes(searchTerm.toLowerCase())) {
              x.push(item);
            }
          }
          console.log("x", x);
          if (x.length) {
            filtered.push({ section: opt.section, options: x });
          }
        }
      }

      console.log("filtered", filtered);
      setFilteredOptions(filtered);
    } else {
      setFilteredOptions(options);
    }
  }, [searchTerm, options]);

  useEffect(() => {
    console.log("filteredOptions", filteredOptions);
  }, [filteredOptions]);

  return (
    <div className="relative">
      {dropdownLabel && (
        <label htmlFor="dropdown-search">{dropdownLabel}</label>
      )}
      <div className="flex items-center">
        <TextField
          id="stock-search"
          type="text"
          // className="w-full border border-gray-300 rounded py-2 px-3 mb-3 leading-tight focus:outline-none focus:border-blue-500"
          placeholder={placeholder}
          value={searchTerm}
          onChange={(e: any) => setSearchTerm(e.target.value)}
          onClick={handleInputClick}
          ref={inputRef}
        />
        {endAdornment && (
          <div onClick={handleInputClick} className="absolute inset-y-0 right-0 top-2.5 flex items-center pointer-events-none">
            {endAdornment}
          </div>
        )}
      </div>
      {showDropdown && (
        <ul className="absolute z-10 bg-white rounded shadow-md py-2 w-full max-h-64 overflow-y-auto">
          {filteredOptions.map((opt: any, index: number) => {
            return (
              <>
                {opt.section ? (
                  <li
                    key={opt.section}
                    className="px-3 text-gray-500 cursor-not-allowed text-bold text-secondary"
                  >
                    {opt.section}
                  </li>
                ) : null}
                {opt.options
                  ? opt.options.map((item: Option) => (
                      <li
                        key={item.value}
                        className={`px-3 cursor-pointer py-1 hover:bg-primary ${
                          selectedOption && selectedOption.value === item.value
                            ? "bg-gray-100"
                            : ""
                        }`}
                        onClick={() => handleOptionClick(item, opt.section)}
                      >
                        {item.label}
                      </li>
                    ))
                  : null}
              </>
            );
          })}
          {filteredOptions.length === 0 && (
            <li className="text-gray-500">No options found</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
